export default __webpack_public_path__ + "static/media/Wider impacts.0bc9f461.pdf";